module.exports = __webpack_public_path__ + "static/media/line_canela.e4312872.jpg";